import type { ViewFilterModifier } from "@regrello/graphql-api";

/** A type that describes the ways in which a __currency__ value can be filtered. */
export type RegrelloFilterDefinition_CurrencyValue = {
  type: "currency";
  filter:
    | { operator: "EQUALS"; value: number; modifier?: ViewFilterModifier }
    | { operator: "LESS_THAN"; value: number; modifier?: ViewFilterModifier }
    | { operator: "GREATER_THAN"; value: number; modifier?: ViewFilterModifier };
};

export const regrelloFilterOperators_CurrencyValue: Record<
  RegrelloFilterDefinition_CurrencyValue["filter"]["operator"],
  true
> = {
  EQUALS: true,
  GREATER_THAN: true,
  LESS_THAN: true,
};

export function getRegrelloDefaultFilterDefinitionCurrencyValue(): RegrelloFilterDefinition_CurrencyValue {
  return {
    type: "currency",
    filter: {
      operator: "EQUALS",
      value: 0,
    },
  };
}
